export default {
  login: {
    login: '登录',
    account: '用户名',
    password: '密码',
    remember: '记住密码',
    forget: '忘记密码',
    privacy_policy: '隐私政策',
    title: 'STAY 管理登录页面'
  },
  lang: {
    ko: '한국인',
    ja: '日本語',
    zh: '中文(简)',
    'zh-Hant': '中文(繁)',
    en: 'English'
  },
  tip: {
    emptyData: '暂无数据',
    login: '用户名和密码不能为空',
    success: '操作成功',
    fail: '操作失败',
    tip: '提示',
    logout: '确定是否退出登录?',
    yes: '确定',
    no: '取消'
  },
  date: {
    week: {
      0: '日',
      1: '一',
      2: '二',
      3: '三',
      4: '四',
      5: '五',
      6: '六'
    }
  },
  header: {
    areaGuide: '区域指南',
    modelCourses: '示范路线',
    travelGuide: '旅游指南',
    tickets: '票务',
    areaGuideDescription: '每个地区都有自己的故事',
    modelCoursesDescription: '为每种旅行风格定制的路线',
    travelGuideDescription: '来自游客的真实体验',
    accessMap: '访问地图',
    accessMapDescription: '从主要城市到这里的方法',
    accessMapTitle: '主要城市访问',
    accessCities: {
      tokyo: {
        name: '从东京',
        description: 'JR・近铁特急',
        time: '约3小时'
      },
      kyoto: {
        name: '从京都',
        description: '近铁特急',
        time: '约2小时30分钟'
      },
      osaka: {
        name: '从大阪',
        description: '近铁特急',
        time: '约2小时'
      },
      nagoya: {
        name: '从名古屋',
        description: '近铁特急',
        time: '约1小时30分钟'
      }
    }
  },
  footer: {
    termsOfService: '使用条款',
    privacyPolicy: '隐私政策',
    specifiedCommercialTransactions: '特定商业交易法',
    contact: '联系我们',
    address: '〒517-0011 三重县鸟羽市鸟羽1-2-3',
    copyright: '© 近畿铁道'
  },
  article: {
    aboutTheCourse: '关于行程',
    author: '作者',
    schedule: '行程安排',
    recommendedPoints: '推荐要点',
    home: '首页',
    regionalIntroduction: '区域介绍',
    iseCity: '伊势市',
    iseshi: '伊势市',
    iseDescription: '一个围绕伊势神宫繁荣的历史小镇，日本人民的心灵圣地。',
    travelGuide: '旅游指南',
    iseSightseeingGourmetGuide: '伊势观光美食指南',
    mustSeeSpots: '必看景点',
    relatedArticles: '相关文章',
    touristGuide: '旅游指南',
    basicGuideToVisitingIseJingu: '参拜伊势神宫的基本指南',
    traveler: '旅行者',
    showMore: '显示更多'
  },
  home: {
    learnMore: '了解更多'
  },
  share: {
    activityCategory: {
      RAILWAY_TICKET: '铁路票务',
      AIRPORT_TRANSPORTATION: '机场交通',
      SHINKANSEN: '新干线',
      EXPRESS_BUS: '高速巴士',
      BUS_TOUR: '巴士观光',
      CRUISES: '游船',
      RENTAL_CAR: '租车',
      CHARTER: '包车',
      ATTRACTION: '景点',
      THEME_PARK: '主题乐园',
      MUSEUM_GALLERY: '博物馆 / 美术馆',
      AQUARIUM_ZOO: '水族馆 / 动物园',
      TEMPLES_SHINES: '寺庙 / 神社',
      TOWER_BUILDING: '塔楼建筑',
      JAPANESE_RESTAURANT: '日式餐厅',
      WESTERN_RESTAURANT: '西式餐厅',
      CHINESE_RESTAURANT: '中式餐厅',
      OTHER_RESTAURANT: '其他餐厅',
      DESSERT_BEVERAGE: '甜品饮品',
      SIGHTSEEING_TOUR: '观光游览',
      MARINE_SPORTS: '水上运动',
      OUTDOOR_ACTIVITIES: '户外活动',
      ONSEN: '温泉',
      SPA_MASSAGE: '水疗按摩',
      JAPANESE_CULTURAL_EXPERIENCE: '日本文化体验',
      JAPANESE_CRAFT_EXPERIENCE: '日本工艺体验',
      JAPANESE_COOKING_EXPERIENCE: '日本料理体验',
      OTHER_EXPERIENCE: '其他体验',
      HOTEL: '酒店',
      RYOKAN: '旅馆',
      VACATION_RENTAL: '度假民宿',
      BUNDLE: '套票',
      PASS: '通票',
      OTHERS: '其他'
    }
  }
};
